import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { LeftArrowIcon } from "../../../../assets/icons/svgicons";
import { isOTPVerified } from "../../../../features/persist/persistSlice";
import {
  generateOTPAction,
  verifyOTPAction,
} from "../../../../features/user/userSlice";
import { validationMessage } from "../../../../Helper/helperfunction";
import { ROUTES } from "../../../../routes";
import {
  FORMIK_REGEX,
  Messages,
  SERVICES,
  SERVICESTYPE,
  isNumber,
} from "../../../../utils/constants";
import Button from "../../../common/Button/Button";
import InputFormik from "../../../common/Formik/Input/InputFormik";
import emailStyles from "./EmailVerification.module.scss";
import styles from "../../../layouts/OnboardLayout/OnboardLayout.module.scss";
import OTP from "../../../common/Formik/OTP/OTP";

const EmailVerification = () => {
  const dispatch = useDispatch();
  const saveSignUpDetail = useSelector((state) => state?.persist?.signUpData);
  const otpVerified = useSelector((state) => state?.persist?.otpVerified);
  const [seconds, setSeconds] = useState();
  const [otp, setOtp] = useState("");
  const history = useNavigate();
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    otp: Yup.string()
      .required(validationMessage("OTP"))
      .matches(FORMIK_REGEX.NUMBER, Messages?.NUMBERVALIDATION),
  });

  const generateOTP = async () => {
    const data = {
      username: await saveSignUpDetail?.email,
      type: SERVICESTYPE?.EMAIL,
      service: SERVICES?.login,
    };

    try {
      const response = await dispatch(generateOTPAction(data));
      if (response?.status === 200) {
        reSetTime();
       
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  const setTime = () => {
    if (!seconds || seconds > 0) {
      const timer = setInterval(() => {
        setSeconds((second) => {
          if (second <= 0) {
            return clearInterval(timer);
          }
          return second - 1;
        });
      }, 1000);
    }
  };
  useEffect(() => {
    if (otpVerified) {
      history(ROUTES.REGISTER, { replace: true });
    } else {
      generateOTP();
    }

  }, []);
  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const data = {
        otp: values?.otp.toString(),
        service: SERVICES?.login,
        username: saveSignUpDetail?.email,
      };
      try {
        const response = await dispatch(verifyOTPAction(data));
        if (response?.status === 200) {
          dispatch(isOTPVerified(true));
          history(ROUTES.SET_NEW_PASSWORD);
        }
      } catch (error) {
        console.log("Something went wrong:", error);
      }
    },
  });

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const reSetTime = () => {
    setSeconds(180); // 3 minutes in seconds
    setTime();
  };

  const handleResend = () => {
    generateOTP();
    setTimer(56);  // reset timer
    setShowBtn(false);
  };

  const [timer, setTimer] = useState(60);
  const [showBtn, setShowBtn] = useState(false);

  useEffect(() => {
    let interval;

    if (timer > 0) {
      setShowBtn(false);
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setShowBtn(true);
    }

    return () => clearInterval(interval);
  }, [timer]);

  return (
    <div className={`${styles.onboard_box} ${emailStyles.email_box}`}>
      <Button
        variant='without_bg_border'
        className='backbtn'
        type="button"
        onClick={() => navigate(-1)}
      >
        <LeftArrowIcon />
        Back
      </Button>
      <h2>Email Verification</h2>
      <p className={`${styles.sub_text} ${emailStyles.sub_text}`}>
        Please enter the 6-digit verification code that was sent to{" "}
        {saveSignUpDetail?.email}. The code is valid for 3 minutes.
      </p>
    
      <form
        method="POST"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <OTP
          name="otp"
          value={formik.values.otp}
          onChange={(val) => {
            formik.setFieldValue("otp", val); // <-- this line important
          }}
          formik={formik}
          placeholder="------"
        />
        <div className={emailStyles.btn_restotp}>
          {showBtn ? (
            <Button
              className={` ${emailStyles.restBtn}`}
              onClick={handleResend}
              type="button"
              variant="without_bg_border"
            >
              Re send
            </Button>
          ) : (
            <p>Re send verification code in {timer}s</p>
          )}
        </div>
      
        <div className={`${styles.submit_btn} mb-0`}>
          <Button
            fluid
            type="button"
            onClick={(e) => {
              formik.handleSubmit(e);
            }}
            disabled={!(formik.isValid && formik.dirty)}
          >
            Continue
          </Button>
        </div>
      </form>
    
    </div>
  );
};

export default EmailVerification;
